/* ==========================================================================
   PDP v2 — vanilla JS, no jQuery dependency.
   Handles: gallery thumbnail switching, variant option selection,
   price/availability updates, quantity guard, size guide popup,
   AJAX add-to-cart with loading state, mobile sticky bar visibility.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format || window.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initSection(root) {
    var sectionId = root.getAttribute('data-section-id');
    var product = (window.pdpV2ProductData || {})[sectionId];
    if (!product) return;

    var form = root.querySelector('.pdp-v2__form');
    var variantIdInput = root.querySelector('.js-pdp-variant-id');
    var priceEl = root.querySelector('.js-pdp-price');
    var compareEl = root.querySelector('.js-pdp-price-compare');
    var discountEl = root.querySelector('.js-pdp-discount');
    var availabilityEl = root.querySelector('.js-pdp-availability');
    var addToCartBtn = root.querySelector('.js-pdp-add-to-cart');
    var qtyInput = root.querySelector('.pdp-v2__qty-input');
    var optionButtons = root.querySelectorAll('.js-pdp-option-value');
    var mainImageWrap = root.querySelector('.js-pdp-main-image');
    var thumbButtons = root.querySelectorAll('.js-pdp-thumb');

    // Current selection state, seeded from the selected/first-available variant.
    var selectedOptions = [];
    if (product.variants && product.variants.length) {
      var seedVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      selectedOptions = seedVariant.options.slice();
    }

    function findVariant(options) {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    function updateOptionButtonStates() {
      optionButtons.forEach(function (btn) {
        var index = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');
        btn.classList.toggle('is-selected', selectedOptions[index] === value);

        var testOptions = selectedOptions.slice();
        testOptions[index] = value;
        var testVariant = findVariant(testOptions);
        btn.classList.toggle('is-unavailable', !!testVariant && !testVariant.available);
      });
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          var textEl = addToCartBtn.querySelector('.pdp-v2__add-to-cart-text');
          if (textEl) textEl.textContent = window.pdpV2Strings && window.pdpV2Strings.unavailable || 'Unavailable';
        }
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl && discountEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          discountEl.textContent = '-' + pct + '%';
          discountEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
          discountEl.style.display = 'none';
        }
      }

      if (availabilityEl) {
        availabilityEl.setAttribute('data-available', variant.available);
        var dot = availabilityEl.querySelector('.pdp-v2__stock-dot');
        var label = variant.available
          ? (window.pdpV2Strings && window.pdpV2Strings.inStock || 'In Stock')
          : (window.pdpV2Strings && window.pdpV2Strings.soldOut || 'Sold Out');
        availabilityEl.innerHTML = '';
        var dotSpan = document.createElement('span');
        dotSpan.className = 'pdp-v2__stock-dot ' + (variant.available ? 'pdp-v2__stock-dot--in' : 'pdp-v2__stock-dot--out');
        availabilityEl.appendChild(dotSpan);
        availabilityEl.appendChild(document.createTextNode(label));
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        var textEl2 = addToCartBtn.querySelector('.pdp-v2__add-to-cart-text');
        if (textEl2) {
          textEl2.textContent = variant.available
            ? (window.pdpV2Strings && window.pdpV2Strings.addToCart || 'Add to Cart')
            : (window.pdpV2Strings && window.pdpV2Strings.soldOut || 'Sold Out');
        }
      }

      var stickyPrice = root.parentElement.querySelector('.js-pdp-sticky-price');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var stickyBtn = root.parentElement.querySelector('.js-pdp-sticky-add-to-cart');
      if (stickyBtn) stickyBtn.disabled = !variant.available;

      if (variant.featured_image && mainImageWrap) {
        var match = mainImageWrap.querySelector('[data-media-id="' + variant.featured_image.id + '"]');
        if (match) {
          mainImageWrap.querySelectorAll('.pdp-v2__main-image-item').forEach(function (el) { el.classList.remove('is-active'); });
          match.classList.add('is-active');
          thumbButtons.forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(variant.featured_image.id));
          });
        }
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');
        selectedOptions[index] = value;
        updateOptionButtonStates();
        var variant = findVariant(selectedOptions);
        updateForVariant(variant);
      });
    });
    updateOptionButtonStates();

    // Gallery thumbnails
    thumbButtons.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        if (mainImageWrap) {
          mainImageWrap.querySelectorAll('.pdp-v2__main-image-item').forEach(function (el) {
            el.classList.toggle('is-active', el.getAttribute('data-media-id') === mediaId);
          });
        }
        thumbButtons.forEach(function (t) {
          var active = t === thumb;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active);
        });
      });
    });

    // Quantity guard
    // Delegated on the form (not the input directly): some storefront platform
    // scripts replace this input with their own quantity widget after load,
    // which would detach a listener bound to the original node.
    if (form) {
      form.addEventListener('change', function (e) {
        var target = e.target;
        if (!target || target.name !== 'quantity') return;
        var min = parseInt(target.getAttribute('min'), 10) || 1;
        var val = parseInt(target.value, 10);
        if (isNaN(val) || val < min) target.value = min;
      });
    }

    // Size guide popup
    var sizeGuideBtn = root.querySelector('.js-pdp-size-guide');
    var sizeGuidePopup = root.querySelector('.js-pdp-size-guide-popup');
    var sizeGuideClose = root.querySelector('.js-pdp-size-guide-close');
    if (sizeGuideBtn && sizeGuidePopup) {
      sizeGuideBtn.addEventListener('click', function () { sizeGuidePopup.hidden = false; });
    }
    if (sizeGuideClose && sizeGuidePopup) {
      sizeGuideClose.addEventListener('click', function () { sizeGuidePopup.hidden = true; });
      sizeGuidePopup.addEventListener('click', function (e) {
        if (e.target === sizeGuidePopup) sizeGuidePopup.hidden = true;
      });
    }

    // AJAX add-to-cart with loading state (Add to Cart only — no Buy Now,
    // no dynamic checkout, per development-phase spec).
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addToCartBtn || addToCartBtn.disabled) return;

        addToCartBtn.classList.add('is-loading');
        addToCartBtn.disabled = true;

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('pdp-v2:added-to-cart', { detail: { sectionId: sectionId } }));
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.disabled = false;
          })
          .catch(function (err) {
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.disabled = false;
            var message = (err && err.description) || 'Could not add this item to your cart.';
            alert(message);
          });
      });
    }

    // Mobile sticky bar — appears once the primary Add to Cart scrolls out of view.
    var stickyBar = root.parentElement.querySelector('.js-pdp-sticky-bar');
    if (stickyBar && addToCartBtn && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          stickyBar.hidden = false;
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      observer.observe(addToCartBtn);
    }
  }

  function init() {
    document.querySelectorAll('.pdp-v2').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.pdp-v2');
    if (root) initSection(root);
  });
})();
